import axios from "axios"

let API_NAME = process.env.VUE_APP_API_NAME;

export default {
  async getContacts(accessToken, search, round_id) {
	  let res = await axios.get(API_NAME + "/contacts?search=" + search + '&round_id=' + round_id, {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
          });
          
    return res.data;
  },
  async saveContact(accessToken, data) {
    let res = await axios.post(API_NAME + "/contacts", data, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async saveContactNote(accessToken, data) {
    let res = await axios.post(API_NAME + "/contact_notes", data, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async getAllPeople(accessToken) {
	  let res = await axios.get(API_NAME + "/people", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
          });
          
    return res.data;
  },
  async getContactSingle(accessToken, contactID) {
    let res = await axios.get(API_NAME + "/contacts/" + contactID, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  async updateContact(accessToken, contactID, form_data) {
    let res = await axios.post(API_NAME + "/contacts/" + contactID,  
          form_data,
        {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
        
      });
      
    return res.data;
  },
  async saveContactApplication(accessToken, data) {
    let res = await axios.post(API_NAME + "/applications", data, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    return res.data;
  },
  
}